import React, { useEffect, useRef } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useSelector } from 'react-redux';
import { isBlank } from '../../utils/BooleanUtility';
import { URL } from '../../config/Constants';
import { useApiCall } from '../../lib/hooksUtil';
import { List } from '../../containers/List';
import colors from '../../theme/Colors';

export default function AlertSection(props) {
  const { previousScreen = '' } = props;

  const { data } = useApiCall(URL.ALERTS, []);
  const authToken = useSelector((state) => state?.UserAccountInfo?.authToken);

  if (isBlank(authToken) || isBlank(data)) return null;

  return (
    <>
      <View style={styles.Container}>
        <Text style={styles.header}>Alerts</Text>
        <List itemData={data} previousScreen={previousScreen} />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  Container: {
    width: '100%',
    paddingHorizontal: 12,
  },
  header: {
    fontSize: 18,
    color: colors.black,
    fontFamily: 'Roboto-Bold',
    paddingBottom: 12,
  },
});
